import React from 'react';

function randomId() {
    return Math.random().toString(36).replace(/[^a-z]+/g, '').substr(2, 10);
}

export class SvgImg extends React.Component {

    constructor(props) {
        super(props);
        this.id = randomId();
    }

    componentDidMount() {
        var $ = window.$;
        var $img = $('#'+this.id);
        var imgURL = this.props.src;
        var imgID = this.props.id;
        var imgClass = this.props.className;
        $.get(imgURL, function (data) {
            var $svg = $(data).find('svg');
            if (typeof imgID !== 'undefined') {
                $svg = $svg.attr('id', imgID);
            }
            if (typeof imgClass !== 'undefined') {
                $svg = $svg.attr('class', imgClass + ' replaced-svg');
            }
            $svg = $svg.removeAttr('xmlns:a');
            if (!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
                $svg.attr('viewBox', '0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width'))
            }
            $img.replaceWith($svg);
        }, 'xml');
    }

    render() {
        return (
            <img src={this.props.src} id={this.id} alt="" />
        )
    }

}


// WEBPACK FOOTER //
// ./src/visual/component/SvgImg.js